import urlcat from 'urlcat';

import { SITE_LOCALES, HELPSHIFT_LOCALES } from '@/constants/locales';

import { HELPSHIFT_BASE_URLS } from '@/config/external';
import { Apps } from '@/constants/apps';

function buildSiteUrl(url: string, localeCode: string): string {
  const locale = SITE_LOCALES[localeCode] || SITE_LOCALES.default;

  return urlcat(url, { locale });
}

function buildHelpshiftUrl(localeCode: string, appName = Apps.Homescapes): string {
  const l = HELPSHIFT_LOCALES[localeCode];

  return urlcat(HELPSHIFT_BASE_URLS[appName], { l });
}

export { buildSiteUrl, buildHelpshiftUrl };
